import { getBreakpoint } from "./getBreakpoint";
export const getGradientWidth = (screenWidth) => {
    const breakpoint = getBreakpoint(screenWidth);
    if (breakpoint === 'mobile') {
        return screenWidth;
    }
    else if (breakpoint === 'tablet') {
        return screenWidth / 1.5;
    }
    else {
        return screenWidth / 2;
    }
};
//# sourceMappingURL=getGradientWidth.js.map